// Pure, stateless helpers extracted from TableView.jsx.
// None of these close over component state — they only depend on their arguments.

export const MS_PER_DAY = 86400000;

export const isAlreadyExistsError = (res) =>
  res?.status === 409 &&
  typeof res?.message === "string" &&
  res.message.toLowerCase().includes("already exists");

export const makeExpandKey = (type, id) => `${type}:${String(id)}`;

// date formatter
export const fmt = (d) => {
  if (!d) return "—";
  const date = new Date(d);
  if (isNaN(date)) return String(d);
  return date.toLocaleDateString();
};

export const getOverdueDays = (endDate) => {
  if (!endDate) return 0;

  const end = new Date(endDate);
  const today = new Date();

  return Math.floor((today - end) / MS_PER_DAY);
};

export const getTodoChecklistProgress = (todo) => {
  const list = todo?.toDoListResponseDTOList || [];
  const total = list.length;
  const done = list.filter(
    (li) =>
      li?.completion ||
      li?.completionFlag ||
      (li?.status && String(li.status).toUpperCase() === "DONE"),
  ).length;
  return { done, total };
};

// Map each user to a stable color bucket 1..5 (same every render)
// eslint-disable-next-line no-unused-vars
export const getAvatarColor = (idOrName) => {
  const str = String(idOrName ?? "");
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return (Math.abs(hash) % 5) + 1;
};

export const calcProgress = (start, end) => {
  if (!start || !end) return { progress: 0, isOverdue: false };
  const startDate = new Date(start);
  const endDate = new Date(end);
  const today = new Date();

  const total = endDate - startDate;
  const elapsed = today - startDate;

  if (total <= 0) return { progress: 0, isOverdue: today > endDate };

  let pct = elapsed / total;
  if (pct < 0) pct = 0;
  if (pct > 1) pct = 1;

  return { progress: pct, isOverdue: today > endDate };
};

export const getPriorityValue = (obj = {}) => obj.priority ?? null;

export const normalizePriority = (p) => {
  if (!p) return null;
  const s = String(p).trim().toLowerCase(); // "low" | "medium" | "high"
  if (["low", "medium", "high"].includes(s)) return s;
  if (["1", "l", "minor"].includes(s)) return "low";
  if (["2", "m", "med", "normal"].includes(s)) return "medium";
  if (["3", "h", "urgent"].includes(s)) return "high";
  return s;
};

// === Priority Tooltip & Badge ===
export const PRIORITY_TIPS = {
  high: [
    "🚀 High priority — let’s keep momentum on this one.",
    "📍 Needs attention soon — stay focused here.",
    "⏰ Important milestone — make it count.",
    "🔥 Key deliverable — plan this first in your day.",
  ],
  medium: [
    "⚡ Medium priority — progress steadily, no rush.",
    "🧭 Keep it on the radar — smooth pace wins.",
    "💡 Mid-level focus — steady contribution counts.",
    "📅 On schedule — just keep it moving.",
  ],
  low: [
    "🌿 Low priority — handle when time allows.",
    "🕊️ Low impact, but still valuable.",
    "☕ No urgency — a good follow-up task.",
    "🌙 Plenty of space — plan it later in the sprint.",
  ],
};

// eslint-disable-next-line no-unused-vars
export const PRIORITY_EMOJI = { high: "", medium: "", low: "" };
